var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.514,
    height: 46.168,
    viewBox: "0 0 35.514 46.168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ion-ios-lock",
    "data-name": "Icon ion-ios-lock",
    d: "M37.824,19.356H35.16V14.173a10.654,10.654,0,1,0-21.308-.144v5.327H11.189A4.452,4.452,0,0,0,6.75,23.8V45.1a4.452,4.452,0,0,0,4.439,4.439H37.824A4.452,4.452,0,0,0,42.263,45.1V23.8A4.452,4.452,0,0,0,37.824,19.356ZM26.06,33.206v7.635a1.591,1.591,0,0,1-1.476,1.6,1.556,1.556,0,0,1-1.631-1.554v-7.68a3.551,3.551,0,1,1,3.107,0Zm5.993-13.85H16.96V14.029a7.546,7.546,0,0,1,15.093,0Z",
    transform: "translate(-6.75 -3.374)",
    fill: "#0a1f3c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.77c27b60814d3a8070326b0ca193f236.svg";
export { ForwardRef as ReactComponent };